<template>
    <div class="container-fluid">
        <div class="row">
            <div class="tabcontent tabcontent-border-style">
                <div class="table-container" v-if="roles.length > 0">
                    <TableComponent :thead="thead" :tbody="roles" @sort="SortRole" :keys="keys"
                                    model="roles" name="role"
                                    updateUrl="/settings/roles/edit" @update="updateRole"/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="getRoles" :limit="3">
                            <template #prev-nav><span>Previous</span></template>
                            <template #next-nav><span>Next</span></template>
                        </pagination>
                    </div>
                </div>

                <div v-else class="d-flex flex-column justify-content-center align-items-center gap-2 h-75 m-auto">
                    <div class="h3Organization">
                        <h3 v-if="!isSearchActive">You Don't Have Any Roles Yet</h3>
                        <h3 v-else>No Data</h3>
                    </div>
                    <router-link class="text-decoration-none btn-container btn-container-no-data"
                                 v-if="permissions.includes('create role') && roles.length === 0 && !isSearchActive"
                                 to="/settings/roles/create">
                        <span>Create Role</span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from "laravel-vue-pagination";
    import roles from "../../../api-services/roles";

    export default {
        name: 'role-indexAdmin',
        props: ['globalSearch', 'globalSort'],
        data() {
            return {
                role: '',
                thead: ['Role Name', 'Members'],
                keys: ['name', 'users_count'],
                roles: [],
                permissions: [],
                originalRoles: [],
                laravelData: {},
                error: null,
                state: false
            }
        },
        computed: {
            isSearchActive() {
                return this.globalSearch !== '';
            }
        },
        watch: {
            globalSearch() {
                this.getRoles(1);
            },
            globalSort() {
                this.getRoles(1);
            }
        },
        mounted() {
            this.role = this.$store.state.auth.user.data.role[0];
            this.permissions = this.$store.state.auth.permissions;
            this.getRoles();
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        methods: {
            getRoles: async function (page = 1) {
                try {
                    const sortVal = this.globalSort !== '' ? this.globalSort : 'desc';
                    const response = await roles.index(this.globalSearch, sortVal, page , true);
                    
                    this.roles = response.data.data;
                    this.laravelData = response.data;
                    this.originalRoles = response.data.data;

                    if (this.roles.length > 0) {
                        this.$emit('data-event', {'role': {action:true, search: this.isSearchActive}});
                    } else {
                        this.$emit('data-event', {'role': {action:false, search: this.isSearchActive}});
                    }

                } catch (e) {
                    this.error = e;
                }
            },
            updateRole(e) {
                let filteredData = this.roles.filter(function (data) {
                    return data.id != e;
                });
                this.roles = filteredData;
            },
            SortRole() {
                let status = !this.state;
                this.originalRoles.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.state = status;
            }
        }
    }
</script>

<style scoped>
    .designRowOrga {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0px;
        margin-bottom: 20px;
    }

    .btnOrganization button {
        background-color: #E95626;
        color: #fff;
        border: none;
        border-radius: 5px;
        justify-content: end;
        align-content: center;
        width: 180px;
        padding: 10px;
    }
    .table-container :deep(thead :first-child){
        width:75% !important;
    }
    .table-container :deep(thead :nth-child(2)){
        width:11% !important;
    }
    @media(max-width:1024px){
        .table-container :deep(thead :first-child){
            width:70% !important;
        }
        .table-container :deep(thead :nth-child(2)){
            width:15% !important;
        }
    }

    /*.tabcontent {*/
    /*    border: 1px solid #032431;*/
    /*    background-color: #032431;*/
    /*    border-radius: 20px;*/
    /*    padding: 23px;*/
    /*}*/
</style>